import React, { FC } from 'react'
import * as Styles from '../../styles'
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import { Highlighted } from 'tabs/data/components/Highlighted'
import { useUnknownQuestions } from '../../context'

export type UnknownQuestionTableRowDisplayProps = {
  question: string
  whoAsked?: string
}

export const QuestionCellContent: FC<UnknownQuestionTableRowDisplayProps> = ({ question }) => {
  const { search } = useUnknownQuestions()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', position: 'relative' }}>
      <Styles.AnswerText>
        <Highlighted text={question} highlight={search} />
      </Styles.AnswerText>
    </div>
  )
}
